import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./UpcomingEvents.css";

const UpcomingEvents = () => {
  return (
    <>
      <div className="upcoming-events grotesk-headings">
        <div className="container">
          <div className="row">
            <h1 className="headings text-center">
              <span>Upcoming </span>Events
            </h1>
          </div>

          <div className="row px-lg-5 px-md-3 mt-md-4 mt-2 px-2">
            <div className="upcoming-box d-flex">
              <div className="row">
                <div className="col-md-4 ">
                  <LazyLoadImage
                    effect="blur"
                    src="https://blueberrywebsites.azureedge.net/bbt/images/upcoming1.png"
                    alt=""
                    className="upcoming1-img"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-8 mt-3 mt-md-0 px-3 px-md-1 ps-md-3">
                  <h5 className="">
                    The Future of Corporate Travel: Trends and Insights for 2024
                  </h5>
                  <div className="d-flex">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/upcoming-calendar.svg"
                      alt=""
                      className="upcoming-calendar"
                      loading="lazy"
                    />
                    <p className="upcoming-date-time">
                      December 10, 2024, at 3:00 PM IST
                    </p>
                  </div>

                  <p className="upcoming-event-description">
                    Gain expert insights into the latest trends shaping
                    corporate travel in 2024. Learn how to optimize your travel
                    strategy for greater efficiency and cost savings.
                  </p>
                  <div className="carouselCaption">
                    <a href="/blog">
                      <button className="btn bg-transparent text-dark mt-lg-2 grotesk-headings fw-bold text-uppercase">
                        READ MORE
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row px-lg-5 px-md-3 my-4 px-2">
            <div className="upcoming-box d-flex">
              <div className="row">
                <div className="col-md-4 ">
                  <LazyLoadImage
                    effect="blur"
                    src="https://blueberrywebsites.azureedge.net/bbt/images/upcoming2.png"
                    alt=""
                    className="upcoming1-img"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-8 mt-3 mt-md-0 px-3 px-md-1 ps-md-3">
                  <h5 className="">
                    Mastering Travel Risk Management for a Safer Tomorrow
                  </h5>
                  <div className="d-flex">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/upcoming-calendar.svg"
                      alt=""
                      className="upcoming-calendar"
                      loading="lazy"
                    />
                    <p className="upcoming-date-time">
                      December 10, 2024, at 3:00 PM IST
                    </p>
                  </div>

                  <p className="upcoming-event-description">
                    Gain expert insights into the latest trends shaping
                    corporate travel in 2024. Learn how to optimize your travel
                    strategy for greater efficiency and cost savings.
                  </p>
                  <div className="carouselCaption">
                    <a href="/blog">
                      <button className="btn bg-transparent text-dark mt-lg-2 grotesk-headings fw-bold text-uppercase">
                        READ MORE
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row px-lg-5 px-md-3 px-2">
            <div className="upcoming-box d-flex">
              <div className="row">
                <div className="col-md-4 ">
                  <LazyLoadImage
                    effect="blur"
                    src="https://blueberrywebsites.azureedge.net/bbt/images/upcoming3.png"
                    alt=""
                    className="upcoming1-img"
                    loading="lazy"
                  />
                </div>
                <div className="col-md-8 mt-3 mt-md-0 px-2 px-md-0 px-3 px-md-1 ps-md-3">
                  <h5 className="">
                    Tech Innovations in Business Travel: What You Need to Know
                  </h5>
                  <div className="d-flex">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/upcoming-calendar.svg"
                      alt=""
                      className="upcoming-calendar"
                      loading="lazy"
                    />
                    <p className="upcoming-date-time">
                      December 10, 2024, at 3:00 PM IST
                    </p>
                  </div>

                  <p className="upcoming-event-description">
                    Gain expert insights into the latest trends shaping
                    corporate travel in 2024. Learn how to optimize your travel
                    strategy for greater efficiency and cost savings.
                  </p>
                  <div className="carouselCaption">
                    <a href="/blog">
                      <button className="btn bg-transparent text-dark mt-lg-2 grotesk-headings fw-bold text-uppercase">
                        READ MORE
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingEvents;
